import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ListConfigProviderEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const listConfigProviderEntrypoint: EntryPoint<ListConfigProviderEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<ListConfigProviderEntrypointComponent>(
			/* webpackChunkName: "ai-rovo-actions-software-list-config-provider" */ './ListConfigProvider.tsx',
		),
		getPreloadProps: () => ({}),
	});
